/**
 * Load runtime config (Option 2 — runtime injection for multi-region).
 * Order: /api/runtime-config (server) → /config/runtime-config.json (recommended for S3) → /runtime-config.json.
 * Use /config/runtime-config.json for one-build multi-region: same artifact, region-specific config per bucket.
 */
const CONFIG_URLS = ['/api/runtime-config', '/config/runtime-config.json', '/runtime-config.json'];

export async function loadRuntimeConfig() {
    const applyConfig = (config) => {
        window.__APP_CONFIG__ = config || {};
        window.__APP_CONFIG__.IS_POSITIVE_MESSAGE = config?.HAPPY_HUMI;
    };

    for (const url of CONFIG_URLS) {
        try {
            const response = await fetch(url, { credentials: 'same-origin' });
            if (response.ok) {
                const config = await response.json();
                applyConfig(config);
                return;
            }
        } catch (_) {
            continue;
        }
    }
    console.warn('Runtime config not found (OK for dev). Using defaults.');
    applyConfig({});
}
